import React from "react"
import PropTypes from "prop-types"
import { Button, ButtonGroup } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import BucketBatches from "./BucketBatches"
import { CardType, fillingZeroUtility, formatCurrency, RevenueType } from "../../../lib/utils"
import AddMoneyCard from "./AddMoneyCard"
import RenderDeposits from "./RenderDeposits"
import OtherCostsTable from "../OtherCostsTable"
import RevenueSharingTable from "./RevenueSharingTable"
import CreatedOnDate from "../../fragments/CreatedOnDate"
import ItemSummary from "../ItemSummary"
import RepaymentSummary from "./RepaymentSummary"

class FinancierBucketCard extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    shouldChangeStatus: false,
    shouldAddMoney: false,
    shouldDelete: false,
    running: false,
    success: false,
    error: null,
  }

  handleAddMoney = () => this.setState({ shouldAddMoney: true })

  handleChangeStatus = () => this.setState({
    shouldChangeStatus: true,
    running: false,
    success: false,
    error: null,
  })

  handleDelete = () => this.setState({
    shouldDelete: true,
    running: false,
    success: false,
    error: null
  })

  confirmChangeStatus = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { financierBucket: { id: bucketId, closed }, setFinancierBucket } = this.props

    blockingFetchService(
      accessToken => apiServerApi.changeStatusFinancierBucket(accessToken, bucketId, !closed),
      resp => {
        this.setState({ success: true })
        setTimeout(() => {
          this.closeStatusForm()
          setFinancierBucket(bucketId, resp)
        }, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { financierBucket: { id: bucketId }, removeFinancierBucket, cardType } = this.props

    blockingFetchService(
      accessToken => apiServerApi.deleteFinancierbucket(accessToken, bucketId),
      _ => {

        this.setState({ success: true })
        setTimeout(() => {
          this.closeDeleteForm()
          removeFinancierBucket(bucketId)
          if (cardType === CardType.LARGE) {
            browserHistory.push('/financiers/buckets')
          }
        }, 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeAddMoney = () => this.setState({ shouldAddMoney: false })

  closeDeleteForm = () => this.setState({ shouldDelete: false })

  closeStatusForm = () => this.setState({ shouldChangeStatus: false })

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this bucket?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateContent = () => {

    const { financierBucket: { closed } } = this.props,
    { running, success, error } = this.state
    return (
      <div>
        <h3>{ closed ? 'Open' : 'Close' } this bucket?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderBtnGroup = (id, closed, nbBatches, isLarge) => (
    <ButtonGroup justified>

      <Button href="#" bsStyle="info" title={ closed ? 'Open' : 'Close' }
        onClick={ this.handleChangeStatus } disabled={ closed && !this.isAdmin }>
        <FontAwesome name={ closed ? 'eye' : 'eye-slash' } /> { closed ? 'Open' : 'Close' }
      </Button>

      { isLarge &&
      <Button href='#' bsStyle='primary' title='Add Money'
        onClick={ this.handleAddMoney } disabled={ closed }>
        <FontAwesome name='dollar' /> Add Money
      </Button>}

      <Button href='#' bsStyle='success' disabled={ !this.isAdmin }
        onClick={() => browserHistory.push(`/financiers/buckets/${id}/update`)}>
        <FontAwesome name='pencil' /> Update
      </Button>

      <Button href='#' bsStyle='warning' disabled={ !this.isAdmin || nbBatches > 0 }
        onClick={ this.handleDelete } title={ nbBatches ? 'Unlink all batches first' : 'Delete' }>
        <FontAwesome name='trash-o' /> Delete
      </Button>

      { isLarge &&
      <Button href='#'
        onClick={() => browserHistory.push('/financiers/buckets/create')}>
        <FontAwesome name='plus-circle' /> New Bucket
      </Button>}
    </ButtonGroup>
  )

  showItem = financierBucket => {

    const { setFinancierBucket, cardType, allUpfrontPayment, allTotalRepayment,
      runningRepaymentSummary } = this.props,

    { id, name, amount, balance, closed, isFull, nbBatches, batches, sellingCost, purchaseCost, 
      margin, commissionFee, transportFee, otherCosts, revenueType, rate,
      currencyCode, createdOn } = financierBucket,

    isLarge = cardType === CardType.LARGE,

    redName = (isFull && closed) ? '(full & closed)' : isFull ? '(full)' : closed ? '(closed)' : ''

    return (
      <div className='detail-content'>

        { this.renderBtnGroup(id, closed, nbBatches, isLarge) }

        <h2 className={ `${(isFull || closed) ? 'red' : 'blue'} mt-20` }>
          { name } { redName && <small className="red">{ redName }</small> }
        </h2>

        <SimpleCardRow name='Amount' value={ formatCurrency(amount) }
          title='Amount = All investor deposits' />

        <SimpleCardRow name='Is Full' value={ isFull ? 'Yes' : 'No' } />

        <SimpleCardRow name='Closed' value={ closed ? 'Yes' : 'No' } />

        <SimpleCardRow name='Currency code' value={ currencyCode ? currencyCode : '-' } />

        <SimpleCardRow name='Nb batches' value={ fillingZeroUtility(nbBatches) } />

        { revenueType === RevenueType.FIXED_RATE
        ? <SimpleCardRow name='Fixed rate' value={ `${ rate }%` } />
        : <SimpleCardRow name='Revenue sharing' value={ 
          <RevenueSharingTable investorRevenue={ rate } /> }
        />}

        <BucketBatches
          batches={ batches }
          bucketId={ id }
          setFinancierBucket={ setFinancierBucket }
          isLarge={ isLarge }
          closed={ closed }
        />

        <RepaymentSummary
          allUpfrontPayment={ allUpfrontPayment }
          allTotalRepayment={ allTotalRepayment }
          running={ runningRepaymentSummary }
        />

        <OtherCostsTable
          commissionFee={ commissionFee }
          transportFee={ transportFee }
        />

        <ItemSummary
          purchaseCost={ purchaseCost }
          sellingCost={ sellingCost }
          otherCosts={ otherCosts }
          balance={ balance }
          margin={ margin }
          isLarge={ isLarge }
        />

        <hr/>
        <CreatedOnDate createdOn={ createdOn } />
      </div>
    )
  }

  renderLargeCard = financierBucket => {

    const dataBreadCrumbs = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/buckets', title: 'Buckets' }
    ],

    { id: bucketId, name, deposits, closed }  = financierBucket,

    { setFinancierBucket } = this.props

    return (
      <div>
        <CustomBreadCrumb activeText={ name } data={ dataBreadCrumbs } />
        <Row>
          <Col md={4}>

            <div className="align-center">
              <FontAwesome name="folder" size="3x" className="detail-icon" />
            </div>

            <RenderDeposits
              deposits={ deposits }
              bucketId={ bucketId }
              setFinancierBucket={ setFinancierBucket }
              closed={ closed }
            />
          </Col>

          <Col md={8}>
            { this.showItem(financierBucket) }
          </Col>
        </Row>
      </div>
    )
  }

  render() {

    const { financierBucket, setFinancierBucket, cardType } = this.props,

    { id: bucketId, name } = financierBucket,

    { shouldChangeStatus, shouldAddMoney, shouldDelete, running } = this.state

    return (
      <div>

        { cardType === CardType.SMALL ? 
          this.showItem(financierBucket) : this.renderLargeCard(financierBucket) }

        <AlertModal
          show={ shouldChangeStatus }
          title="Confirm update"
          body={ this.renderUpdateContent() }
          bsStyle="danger"
          close={ this.closeStatusForm }
          confirm={ this.confirmChangeStatus }
          proceedText="Proceed"
          disabled={ running }
        />

        <AddMoneyCard
          show={ shouldAddMoney }
          close={ this.closeAddMoney }
          bucketId={ bucketId }
          bucketName={ name }
          setFinancierBucket={ setFinancierBucket }
        />

        <AlertModal
          show={ shouldDelete }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

FinancierBucketCard.propTypes = {
  financierBucket: PropTypes.object.isRequired,
}

export default FinancierBucketCard



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/Card.js